import type { Messages } from "@/i18n/messages/sq"

export const de: Messages = {
    meta: {
        lang: "de",
        dir: "ltr",
        siteTagline: "Verlag, Übersetzungen und Kurse",
        siteDescription:
            "Das Germa-Institut ist eine kulturelle und pädagogische Einrichtung für Verlagsarbeit, Übersetzungen, Korankurse und Fremdsprachenunterricht."
    },

    languageNames: {
        sq: "Albanisch",
        en: "Englisch",
        de: "Deutsch",
        es: "Spanisch",
        tr: "Türkisch",
        bs: "Bosnisch",
        ar: "Arabisch"
    },

    common: {
        home: "Startseite",
        homeAria: "Germa-Institut, Startseite",
        breadcrumb: "Brotkrümelnavigation",
        mainNav: "Hauptnavigation",
        menu: "Menü",
        openMenu: "Menü öffnen",
        closeMenu: "Menü schließen",
        contactUs: "Kontakt aufnehmen",
        language: "Sprache",
        chooseLanguage: "Sprache der Website wählen",
        instituteName: "Germa-Institut"
    },

    nav: {
        libra: "Bücher",
        kurani: "Koran",
        videoleksione: "Videolektionen",
        kurse: "Kurse",
        audiolibra: "Hörbücher",
        rrethNesh: "Über uns",
        kontakt: "Kontakt"
    },

    footer: {
        tagline:
            "Wir veröffentlichen und übersetzen islamische Literatur und bieten Kurse zum Koranlesen und zum Erlernen von Fremdsprachen an.",
        links: "Schnellzugriff",
        books: "Bücher",
        allBooks: "Alle Bücher",
        contact: "Kontakt",
        contactNote:
            "Schreiben Sie uns, um Bücher zu bestellen, sich für einen Kurs anzumelden oder eine Zusammenarbeit vorzuschlagen.",
        rights: "Alle Rechte vorbehalten."
    },

    verse: {
        text: "Und sag: „Mein Herr, mehre mich an Wissen.“",
        source: "Koran, 20:114"
    },

    home: {
        seoDescription:
            "Kostenlose Bücher zum Herunterladen, Videolektionen, Hörbücher sowie Kurse zum Koranlesen und für Fremdsprachen vom Germa-Institut.",
        hero: {
            eyebrow: "Willkommen",
            intro:
                "Das Germa-Institut ist eine kulturelle und pädagogische Einrichtung. Wir veröffentlichen religiöse, sprachliche und pädagogische Bücher, erstellen Videolektionen und bieten Kurse zum Koranlesen und für Fremdsprachen an.",
            primaryCta: "Bücher entdecken",
            secondaryCta: "Für einen Kurs anmelden",
            pillars: ["Bücher", "Videolektionen", "Kurse", "Hörbücher"],
            cue: "Mehr entdecken",
            category: "Publikation",
            viewBook: "Zum Buch",
            previous: "Vorheriges Buch",
            next: "Nächstes Buch",
            goTo: "Zu Buch {number}"
        },
        marquee: {
            rowOne: ["Verlag", "Übersetzungen", "Korankurse", "Videolektionen", "Hörbücher", "Fremdsprachen"],
            rowTwo: ["Das quranische Alphabet", "Tadschwid", "Wissen", "Bildung", "Erbe", "Moderne Methodik"]
        },
        about: {
            eyebrow: "Über das Institut",
            title: "Im Dienst von Wissen und Bildung",
            intro:
                "Mit unserer Arbeit möchten wir Menschen beim Lernen begleiten, ihnen helfen, ihre Religion besser kennenzulernen, und ihre Sprachkenntnisse fördern. Deshalb achten wir darauf, dass unsere Bücher und Lernmaterialien inhaltlich korrekt und verständlich erklärt sind und dass sich unsere Kurse am Wissensstand und an den Bedürfnissen der Lernenden orientieren.",
            features: [
                "Veröffentlichung und Übersetzung religiöser, sprachlicher und pädagogischer Literatur.",
                "Kurse zum Koranlesen und für Fremdsprachen, online und vor Ort.",
                "Videolektionen und Hörbücher, die Sie jederzeit online nutzen können."
            ]
        },
        stats: {
            titles: "Veröffentlichte Titel",
            languages: "Publikationssprachen",
            fields: "Tätigkeitsbereiche",
            online: "Online verfügbar"
        },
        services: {
            eyebrow: "Unser Angebot",
            title: "Unsere Tätigkeitsfelder",
            more: "Mehr erfahren",
            items: {
                libra: {
                    title: "Bücher",
                    description:
                        "Religiöse, sprachliche und pädagogische Bücher, verfasst oder übersetzt vom Germa-Institut.",
                    cta: "Zu den Büchern"
                },
                videoleksione: {
                    title: "Videolektionen",
                    description: "Videolektionen zum Koranlesen und zu weiteren religiösen und pädagogischen Themen.",
                    cta: "Zu den Videolektionen"
                },
                kurse: {
                    title: "Kurse",
                    description: "Kurse zum Koranlesen und für Fremdsprachen, vor Ort und online.",
                    cta: "Zu den Kursen"
                },
                audiolibra: {
                    title: "Hörbücher",
                    description: "Unsere Publikationen als Hörbuch, für alle, die lieber zuhören.",
                    cta: "Zu den Hörbüchern"
                }
            }
        },
        booksLocal: {
            title: "Bücher auf Deutsch",
            description: "Unsere deutschsprachigen Ausgaben, alle kostenlos zum Herunterladen."
        },
        booksOther: {
            title: "Bücher in weiteren Sprachen",
            description: "Unsere Publikationen auf Albanisch und in weiteren Sprachen, ebenfalls kostenlos zum Herunterladen."
        },
        booksCarouselTitle: "Bücher, die bleiben",
        booksCarouselDescription:
            "Religiöse, pädagogische und kulturelle Werke, sorgfältig für ihre Leserinnen und Leser aufbereitet.",
        seeAllBooks: "Alle Bücher ansehen",
        mostRead: {
            eyebrow: "Beliebt bei Lesern",
            title: "Am meisten gelesen",
            description: "Die Bücher, die unsere Leserinnen und Leser am häufigsten öffnen und herunterladen."
        },
        kurani: {
            badge: "Ein besonderes Projekt",
            title: "Der edle Koran",
            subtitle: "Übersetzung seiner Bedeutungen ins Albanische",
            text: "Lesen Sie den Koran zusammen mit der Übersetzung seiner Bedeutungen ins Albanische von Jusuf H. Kastrati, kostenlos auf Kurani.info.",
            cta: "Über die Übersetzung",
            readOn: "Auf Kurani.info lesen",
            logoAlt: "Logo der Plattform Kurani.info",
            highlights: [
                {
                    title: "Genau und werktreu",
                    text: "Die Bedeutungen der Verse werden sorgfältig wiedergegeben, gestützt auf anerkannte Tafsir-Werke."
                },
                {
                    title: "Klares, flüssiges Albanisch",
                    text: "Ein natürliches Albanisch, das die Eigenart des koranischen Ausdrucks bewahrt, soweit die Sprache es zulässt."
                },
                {
                    title: "Erläuternde Fußnoten",
                    text: "Kurze Anmerkungen, die dort beim Verständnis der Verse helfen, wo eine Erklärung nötig ist."
                }
            ]
        }
    },

    cta: {
        eyebrow: "Machen Sie mit",
        title: "Sie möchten einen Kurs besuchen, unsere Publikationen bestellen oder mit uns zusammenarbeiten? Schreiben Sie uns.",
        primary: "Zu den Kursen",
        secondary: "Kontakt aufnehmen"
    },

    books: {
        seoTitle: "Islamische Bücher",
        seoDescription:
            "Der Katalog des Germa-Instituts: religiöse, pädagogische und kulturelle Bücher auf Deutsch, Albanisch und in weiteren Sprachen, professionell übersetzt und lektoriert.",
        listName: "Publikationen des Germa-Instituts",
        title: "Unsere Publikationen",
        description:
            "Hier finden Sie unsere Publikationen auf Deutsch, Albanisch und in weiteren Sprachen, alle kostenlos zum Herunterladen.",
        crumb: "Bücher",
        searchLabel: "Bücher durchsuchen",
        searchPlaceholder: "Nach Titel oder Autor suchen",
        authorChip: "Autor: {name}",
        clearAuthor: "Autorenfilter entfernen",
        clearSearch: "Suche löschen",
        categoryLabel: "Kategorie",
        allCategories: "Alle Kategorien",
        languageLabel: "Sprache",
        allLanguages: "Alle Sprachen",
        readingList: "Meine Leseliste",
        readingListHintBefore: "Tippen Sie auf das Symbol",
        readingListHintAfter: "an einem Buch, um es hier zu speichern.",
        readingListEmpty:
            "Ihre Leseliste ist noch leer. Tippen Sie bei jedem Buch, das Sie später lesen möchten, auf das Lesezeichen.",
        foundOne: "1 Buch gefunden",
        foundMany: "{count} Bücher gefunden",
        noResults: "Für diese Auswahl wurden keine Bücher gefunden.",
        showAll: "Alle Bücher anzeigen",
        groupLocal: "Auf Deutsch",
        groupOther: "In weiteren Sprachen",
        mostRead: "Meistgelesen",
        publishedBy: "Herausgegeben vom Germa-Institut",
        viewBook: "Buch ansehen: {title}",
        coverAlt: "Cover von „{title}“",
        save: "Auf meine Liste",
        saved: "Auf meiner Liste",
        remove: "Von meiner Liste entfernen"
    },

    bookPage: {
        lang: "de",
        dir: "ltr",
        about: "Über das Buch",
        highlights: "Das Wichtigste",
        details: "Details",
        language: "Sprache",
        languageName: "Deutsch",
        category: "Kategorie",
        author: "Autor",
        authorLine: "Autor: {author}.",
        publishedBy: "Herausgegeben vom Germa-Institut.",
        fallbackDescription: "{title}. Ein Buch auf {language}.",
        publisher: "Verlag",
        cta: "Interesse an diesem Buch? Schreiben Sie uns für eine Bestellung oder weitere Informationen.",
        contact: "Kontakt aufnehmen",
        home: "Startseite",
        books: "Bücher",
        book: "Buch",
        breadcrumb: "Brotkrümelnavigation",
        coverAlt: "Cover von „{title}“",
        readOnline: "Online lesen",
        orderOrAsk: "Bestellen oder anfragen",
        allBooks: "Alle Bücher",
        readerTitle: "Das Buch online lesen",
        readerText: "Blättern Sie das ganze Buch direkt hier durch, kostenlos.",
        openNewTab: "In neuem Tab öffnen",
        relatedEyebrow: "Weiterlesen",
        moreByAuthor: "Weitere Bücher dieses Autors",
        allByAuthor: "Alle Bücher dieses Autors",
        authorLinkTitle: "Bücher dieses Autors ansehen",
        relatedTitle: "Das könnte Sie auch interessieren",
        seeAllBooks: "Alle Bücher ansehen",
        otherEditions: "Dieses Buch in anderen Sprachen",
        watchVideos: "Videolektionen ansehen",
        downloadPdf: "PDF herunterladen",
        continueFrom: "Weiterlesen ab Seite {page}",
        startOver: "Von vorne beginnen",
        page: "Seite",
        pageOf: "von",
        prevPage: "Vorherige Seite",
        nextPage: "Nächste Seite",
        zoomIn: "Vergrößern",
        zoomOut: "Verkleinern",
        fullscreen: "Vollbild",
        closeReader: "Leser schließen",
        loadingBook: "Das Buch wird geöffnet…",
        readerError: "Das Buch konnte hier nicht geöffnet werden. Öffnen Sie es in einem neuen Tab.",
        saveBook: "Auf meine Liste",
        savedBook: "Auf meiner Liste",
        share: "Teilen",
        copyLink: "Link kopieren",
        linkCopied: "Link kopiert",
        email: "E-Mail",
        moreOptions: "Weitere Optionen",
        displaySettings: "Leseansicht",
        themeLight: "Tag",
        themeSepia: "Sepia",
        themeNight: "Nacht",
        pageSize: "Textgröße",
        reviews: {
            title: "Bewertungen der Leser",
            intro: "Wie gefällt Ihnen dieses Buch? Vergeben Sie Sterne und, wenn Sie möchten, ein paar Worte für andere Leser.",
            average: "{average} von 5",
            count: "{count} Bewertungen",
            countOne: "1 Bewertung",
            empty: "Dieses Buch hat noch keine Bewertungen. Seien Sie der Erste, der es bewertet.",
            formTitle: "Buch bewerten",
            ratingLabel: "Ihre Bewertung",
            star: "{count} Sterne",
            starOne: "1 Stern",
            name: "Ihr Name",
            namePlaceholder: "z. B. Lena",
            comment: "Kommentar (freiwillig)",
            commentPlaceholder: "Was hat Ihnen an diesem Buch gefallen?",
            submit: "Bewertung senden",
            sending: "Wird gesendet…",
            success: "Vielen Dank! Ihre Bewertung erscheint, sobald das Institut sie geprüft hat.",
            errorRating: "Bitte wählen Sie, wie viele Sterne Sie dem Buch geben.",
            errorName: "Bitte geben Sie Ihren Namen ein (mindestens zwei Buchstaben).",
            errorThrottled: "Sie haben heute schon viele Bewertungen gesendet. Bitte versuchen Sie es morgen erneut.",
            error: "Die Bewertung konnte nicht gesendet werden. Bitte versuchen Sie es gleich noch einmal.",
            moderated: "Bewertungen erscheinen, nachdem das Institut sie geprüft hat."
        },
        quote: {
            button: "Zitat teilen",
            title: "Ein Zitat teilen",
            intro: "Markieren Sie mit Maus oder Finger einen Satz auf der Buchseite oder schreiben Sie ihn hier. Wir machen daraus ein Bild für Instagram oder WhatsApp.",
            textLabel: "Zitat",
            placeholder: "Schreiben oder fügen Sie den Satz ein, der Sie berührt hat…",
            formatLabel: "Bildformat",
            square: "Quadratisch (Beitrag)",
            story: "Hochformat (Story)",
            share: "Bild teilen",
            download: "Bild herunterladen",
            copyText: "Text kopieren",
            copied: "Text kopiert",
            close: "Schließen",
            tooLong: "Das Zitat ist zu lang. Bitte kürzen Sie es (bis zu {max} Zeichen).",
            empty: "Schreiben Sie ein Zitat, damit es auf dem Bild erscheint.",
            fromSelection: "Als Zitat teilen",
            preview: "Vorschau des Bildes",
            shareText: "Aus dem Buch „{title}“"
        }
    },

    share: {
        share: "Teilen",
        copyLink: "Link kopieren",
        linkCopied: "Link kopiert",
        email: "E-Mail",
        moreOptions: "Weitere Optionen"
    },

    audiobooks: {
        seoTitle: "Islamische Hörbücher auf Albanisch",
        seoDescription:
            "Religiöse und pädagogische Hörbücher auf Albanisch, klar und professionell gelesen. Direkt auf der Seite anhören, jederzeit und auf jedem Gerät.",
        listName: "Hörbücher des Germa-Instituts",
        title: "Hörbücher auf Albanisch",
        description:
            "Unsere Publikationen als Hörbuch, auf Albanisch. Hören Sie sie direkt hier auf der Seite oder laden Sie sie kostenlos herunter, ganz ohne Anmeldung.",
        crumb: "Hörbücher",
        comingSoon: "Demnächst",
        comingSoonText: "Unsere Hörbücher sind in Vorbereitung. Folgen Sie unseren Kanälen, um sie als Erste zu hören.",
        badge: "Hörbuch",
        author: "Autor:",
        openBook: "Zum Buch",
        resumeFrom: "Weiter ab {time}",
        back15: "15 Sekunden zurück",
        forward15: "15 Sekunden vor",
        play: "Abspielen",
        pause: "Pausieren",
        position: "Wiedergabeposition",
        speedGroup: "Wiedergabegeschwindigkeit",
        speed: "Tempo",
        speedValue: "Tempo {value}",
        download: "Hörbuch herunterladen",
        youtube: "Auf YouTube anhören",
        miniLabel: "Sie hören gerade",
        closePlayer: "Player schließen",
        openAudiobook: "Zum Hörbuch",
        coverAlt: "Cover des Hörbuchs „{title}“",
        otherAudiobooks: "Weitere Hörbücher",
        allAudiobooks: "Alle Hörbücher",
        openPage: "Seite des Hörbuchs öffnen",
        pageSeoDescription: "Hören Sie das Hörbuch „{title}“ auf Albanisch kostenlos direkt auf der Seite oder laden Sie es ohne Anmeldung herunter."
    },

    videos: {
        seoTitle: "Videolektionen: Koran lesen lernen",
        seoDescription:
            "{count} kostenlose Videolektionen zum Erlernen der Buchstaben des Korans, auf Albanisch, Deutsch und Englisch, vom ersten Buchstaben bis zum flüssigen Lesen.",
        listName: "Videolektionen des Germa-Instituts",
        title: "Koran lesen lernen",
        description:
            "Mit den Videolektionen zum quranischen Alphabet lernen Sie Schritt für Schritt die arabischen Buchstaben und das Lesen des Korans. Die Lektionen gibt es auf Albanisch, Deutsch und Englisch, kostenlos und ohne Anmeldung direkt auf dieser Seite.",
        crumb: "Videolektionen",
        chooseLanguage: "Sprache wählen:",
        player: {
            videos: "Videos",
            youtube: "Auf YouTube ansehen",
            list: "Lektionsliste",
            promo: "Einführungsvideo",
            promoShort: "Intro",
            lesson: "Lektion",
            of: "von",
            playing: "Wird abgespielt",
            shareLesson: "Lektion teilen",
            openBook: "Zum Buch",
            markDone: "Als gelernt markieren",
            done: "Gelernt",
            progress: "gelernt",
            resume: "Weiter mit",
            lessonsDone: "{done} von {total} Lektionen gelernt",
            progressLabel: "Fortschritt in dieser Reihe",
            seriesDone: "Sie haben diese Reihe abgeschlossen. Sehr gut!",
            progressHint: "Markieren Sie die gelernten Lektionen und verfolgen Sie Ihren Fortschritt.",
            prevLesson: "Vorherige Lektion",
            nextLesson: "Nächste Lektion",
            allLessons: "Alle Lektionen der Reihe",
            watchOnYoutube: "Auf YouTube ansehen",
            aboutLesson: "Über diese Lektion",
            backToSeries: "Zurück zur Reihe",
            openLessonPage: "Seite der Lektion öffnen",
            lessonIntro: "Lektion {number} von {total} der Reihe „{series}“.",
            promoIntro: "Einführungsvideo der Reihe „{series}“.",
            freeLesson: "Eine kostenlose Videolektion des Germa-Instituts, ohne Anmeldung."
        }
    },

    courses: {
        seoTitle: "Koran- und Sprachkurse",
        seoDescription:
            "Korankurse von den ersten Buchstaben bis zum Lesen mit Tadschwid sowie Sprachkurse. Online und vor Ort, die Anmeldung ist geöffnet.",
        listName: "Kurse des Germa-Instituts",
        title: "Kurse zum Koranlesen und für Sprachen",
        description:
            "Wir bieten Kurse für Einsteiger und für alle, die ihre Kenntnisse vertiefen möchten. Je nach Kurs und Gruppe findet der Unterricht online oder vor Ort statt.",
        crumb: "Kurse",
        posterAlt: "Plakat zum Kurs „{title}“",
        teacher: "Lehrerin:",
        details: "Zu den Kursdetails",
        listTitle: "Unsere Kurse",
        listDescription:
            "Wir unterrichten das Koranlesen und Tadschwid und planen, auch unseren Arabischkurs wieder aufzunehmen. Termine, Uhrzeiten und Anmeldung werden für jede neue Gruppe bekannt gegeben.",
        registerTitle: "Möchten Sie an einem Kurs teilnehmen?",
        registerDescription:
            "Füllen Sie das Formular aus, um uns Ihr Interesse mitzuteilen. Sobald für den gewählten Kurs eine neue Gruppe startet, melden wir uns mit dem Starttermin, dem Stundenplan und allen Informationen zum Ablauf.",
        plannedSuffix: "Wiederaufnahme geplant",
        contactFallback: "Kontakt aufnehmen",
        items: {
            "shkronjat-e-kuranit": {
                title: "Koran lesen lernen",
                description:
                    "Ein Kurs für Anfängerinnen auf Grundlage des Buches „Das quranische Alphabet“. Am Anfang stehen das Erkennen und die Aussprache der arabischen Buchstaben, danach geht es um ihre Verbindung zu Wörtern und um Übungen zum Koranlesen.",
                level: "Für Anfängerinnen",
                format: "Online",
                badge: "Für Einsteiger",
                summary:
                    "Ein Kurs auf Grundlage des Buches „Das quranische Alphabet“: vom Erkennen und Aussprechen der arabischen Buchstaben bis zu ihrer Verbindung zu Wörtern und ersten Leseübungen.",
                cta: "Nach neuen Gruppen fragen"
            },
            "leximi-me-texhvid": {
                title: "Tadschwid lernen",
                description:
                    "Die Regeln des Tadschwid lernen und anwenden, mit praktischen Übungen und Korrektur der eigenen Rezitation.",
                level: "Für alle, die den Koran bereits lesen können",
                format: "Online",
                badge: "",
                summary: "",
                cta: "Nach neuen Gruppen fragen"
            },
            "gjuha-arabe": {
                title: "Arabische Sprache",
                description:
                    "Ein Kurs zum Lesen, Schreiben und Verstehen der arabischen Sprache. Details folgen, sobald der Neustart des Kurses feststeht.",
                level: "Wiederaufnahme geplant",
                format: "Online",
                badge: "",
                summary: "",
                cta: "Mehr Informationen anfragen"
            }
        }
    },

    courseForm: {
        name: "Vor- und Nachname",
        phone: "Telefonnummer",
        email: "E-Mail-Adresse",
        course: "Gewünschter Kurs",
        message: "Nachricht",
        optional: "(optional)",
        messagePlaceholder: "Notieren Sie hier Ihre Fragen oder Wünsche.",
        notice: "Das Ausfüllen des Formulars ist noch keine verbindliche Anmeldung zum Kurs.",
        submit: "Anfrage senden",
        submitting: "Wird gesendet…",
        successTitle: "Anfrage gesendet",
        successText:
            "Vielen Dank für Ihr Interesse. Wir melden uns, sobald für den gewählten Kurs eine neue Gruppe startet.",
        again: "Weitere Anfrage senden",
        errors: {
            name: "Bitte geben Sie Ihren Namen ein.",
            phone: "Bitte geben Sie eine gültige Telefonnummer ein.",
            email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            course: "Bitte wählen Sie einen Kurs.",
            generic: "Ihre Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut."
        }
    },

    contact: {
        seoTitle: "Kontakt",
        seoDescription:
            "Schreiben Sie dem Germa-Institut für Buchbestellungen, die Anmeldung zu Koran- und Sprachkursen oder eine Zusammenarbeit. Wir antworten so schnell wie möglich.",
        title: "Kontakt aufnehmen",
        description:
            "Schreiben Sie uns für Buchbestellungen, Kursanmeldungen, eine Zusammenarbeit oder Fragen zu unserer Arbeit.",
        crumb: "Kontakt",
        howTitle: "So erreichen Sie uns",
        howText: "Schreiben Sie uns per E-Mail oder über das Formular.",
        email: "E-Mail",
        response: "Antwortzeit",
        responseValue: "Innerhalb von 3 Tagen",
        follow: "Folgen Sie uns in den sozialen Medien"
    },

    contactForm: {
        name: "Vor- und Nachname",
        namePlaceholder: "Ihr vollständiger Name",
        email: "E-Mail-Adresse",
        emailPlaceholder: "sie@beispiel.de",
        subject: "Betreff",
        optional: "(optional)",
        subjectPlaceholder: "Worum geht es?",
        message: "Nachricht",
        messagePlaceholder: "Schreiben Sie hier Ihre Nachricht.",
        submit: "Nachricht senden",
        submitting: "Wird gesendet…",
        successTitle: "Vielen Dank!",
        successText: "Ihre Nachricht wurde erfolgreich gesendet. Wir antworten Ihnen so bald wie möglich.",
        again: "Weitere Nachricht senden",
        errors: {
            name: "Bitte geben Sie Ihren Namen ein.",
            email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            message: "Bitte schreiben Sie eine etwas ausführlichere Nachricht.",
            generic: "Ihre Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut."
        }
    },

    about: {
        seoTitle: "Über uns",
        seoDescription:
            "Das Germa-Institut ist eine kulturelle und pädagogische Einrichtung, gegründet von Jusuf Kastrati, für Publikationen, Übersetzungen sowie Koran- und Sprachkurse.",
        title: "Germa-Institut",
        description: "Im Dienst von Wissen und Bildung, durch Bücher und Unterricht.",
        crumb: "Über uns",
        missionTitle: "Unser Auftrag",
        mission: [
            "Das Germa-Institut ist eine kulturelle und pädagogische Einrichtung, die in den Bereichen Verlagswesen, Übersetzung und Unterricht tätig ist. Wir veröffentlichen religiöse, sprachliche und pädagogische Literatur, bieten Kurse zum Koranlesen und für Sprachen an und erstellen Videolektionen und Lernmaterialien.",
            "Bei unseren Publikationen achten wir besonders auf inhaltliche Genauigkeit, eine sorgfältige Übersetzung und ein gründliches Lektorat. In unseren Kursen verbinden wir Erklärungen mit praktischen Übungen, abgestimmt auf das Niveau und die Bedürfnisse der Lernenden."
        ],
        valuesTitle: "Die Grundsätze unserer Arbeit",
        values: [
            {
                title: "Genauigkeit",
                text: "Wir stützen uns auf verlässliche Quellen und prüfen jeden Inhalt vor der Veröffentlichung sorgfältig auf religiöse und sprachliche Richtigkeit."
            },
            {
                title: "Verständlichkeit",
                text: "Wir schreiben flüssig und verständlich und erklären Begriffe und Themen, die Vorwissen voraussetzen."
            },
            {
                title: "Nähe zu den Lernenden",
                text: "Wir passen den Unterricht an Alter und Vorkenntnisse an, geben Fragen Raum und begleiten alle Schritt für Schritt."
            },
            {
                title: "Verantwortung",
                text: "Hinweise und Anregungen sind uns willkommen, und Fehler in unseren Publikationen und Materialien korrigieren wir."
            }
        ],
        leadership: "Leitung",
        founderShort: "Gründer & Leiter",
        portraitAlt: "Porträt von {name}",
        directorRole: "Gründer und Leiter des Germa-Instituts",
        directorBio: [
            "Das Germa-Institut wird von seinem Gründer und Leiter Jusuf Kastrati geführt. Er studierte an der Scharia-Fakultät der Islamischen Universität Imam Muhammad ibn Saud in Riad mit dem Schwerpunkt islamische Rechtswissenschaft und ihre Grundlagen. An derselben Universität schloss er auch ein Masterstudium in Islamischer Kultur ab und promoviert derzeit im Fach Islamische Zivilisation an der Universität Ez-Zitouna in Tunesien.",
            "Er verfügt über langjährige Erfahrung in der Übersetzung islamischer Literatur und im Unterricht. Er hat religiöse Bücher übersetzt und Kurse zum Koranlesen und zur arabischen Sprache gegeben, mit Erklärungen auf Albanisch und Deutsch. Einen besonderen Teil seiner Arbeit widmet er der religiösen Bildung junger Menschen."
        ]
    },

    kurani: {
        seoTitle: "Der edle Koran mit albanischer Bedeutungsübersetzung",
        seoDescription:
            "Lesen Sie den arabischen Text des Korans zusammen mit der Übersetzung seiner Bedeutungen ins Albanische von Jusuf Kastrati, kostenlos auf Kurani.info.",
        title: "Der edle Koran",
        subtitle: "Übersetzung seiner Bedeutungen ins Albanische",
        description:
            "Lesen Sie den Koran zusammen mit der Übersetzung seiner Bedeutungen ins Albanische von Jusuf H. Kastrati. Die Übersetzung ist kostenlos auf Kurani.info zugänglich.",
        crumb: "Koran",
        readOn: "Auf Kurani.info lesen",
        logoAlt: "Logo der Plattform Kurani.info",
        aboutTitle: "Über die Übersetzung",
        about: [
            "Diese Übersetzung wurde erarbeitet, um albanischen Lesern die Bedeutungen der Verse genau und in einem klaren, flüssigen Albanisch zu vermitteln. Sie stützt sich auf anerkannte Tafsir-Werke und wurde mehrfach religiös und sprachlich überprüft.",
            "Jede Übersetzung ist ein menschlicher Versuch, die Bedeutungen der Verse wiederzugeben, und kann den sprachlichen und inhaltlichen Reichtum des Originals nie vollständig erfassen. Sie ist daher eine Hilfe zum Verständnis des Korans, während der Koran selbst das von Allah auf Arabisch offenbarte Buch bleibt."
        ],
        featuresTitle: "Merkmale der Übersetzung",
        features: [
            {
                title: "Genau und werktreu",
                text: "Sorgfältige Wiedergabe der Bedeutungen der Verse, gestützt auf anerkannte Tafsir-Werke."
            },
            {
                title: "Klares, flüssiges Albanisch",
                text: "Ein klares und flüssiges Albanisch, das die Eigenart des koranischen Ausdrucks bewahrt, soweit die Sprache es zulässt."
            },
            {
                title: "Einheitlicher Stil und Fachwortschatz",
                text: "Eine einheitliche Terminologie, bei der etablierte islamische Begriffe des Albanischen beibehalten werden."
            },
            {
                title: "Kurze Fußnoten",
                text: "Erläuterungen, die beim Verständnis der Verse helfen, wo eine zusätzliche Erklärung nötig ist."
            },
            {
                title: "Religiöse und sprachliche Prüfung",
                text: "Wiederholte Prüfung durch Fachleute der jeweiligen Gebiete, für die Genauigkeit der Bedeutungen und des albanischen Ausdrucks."
            },
            {
                title: "Freier Zugang",
                text: "Die Übersetzung kann kostenlos online gelesen werden. Die digitale Fassung lässt sich mit weiteren Korrekturen und Verbesserungen aktualisieren."
            }
        ],
        translatorBadge: "Übersetzer",
        translatorRole: "Doktorand im Fach Islamische Zivilisation",
        translatorText:
            "Die Übersetzung der Bedeutungen des edlen Korans ins Albanische ist das Ergebnis langjähriger Forschungs-, Übersetzungs- und Redaktionsarbeit.",
        teamTitle: "Redaktions- und Prüfungsteam",
        roles: {
            religious: "Religiöse Redaktion",
            consulting: "Religiöse Beratung",
            language: "Sprachliche Redaktion"
        },
        noteTitle: "Hinweis",
        note: "Diese Übersetzung befindet sich in der abschließenden Phase der Redaktion und wissenschaftlichen Prüfung. Wir freuen uns über jeden Hinweis und jede Anregung, die hilft, die Bedeutungen des edlen Korans möglichst genau wiederzugeben.",
        writeUs: "Schreiben Sie uns",
        ctaTitle: "Die Übersetzung lesen",
        ctaText: "Den arabischen Text, die albanische Übersetzung und die erläuternden Fußnoten finden Sie auf Kurani.info.",
        ctaButton: "Kurani.info öffnen"
    },

    search: {
        open: "Suchen",
        title: "Im Portal suchen",
        placeholder: "Bücher, Hörbücher, Videolektionen, Kurse suchen…",
        close: "Suche schließen",
        hint: "Geben Sie mindestens zwei Buchstaben ein.",
        empty: "Keine Ergebnisse für „{query}“.",
        error: "Die Suche hat nicht funktioniert. Bitte versuchen Sie es gleich noch einmal.",
        loading: "Suche läuft…",
        groups: {
            books: "Bücher",
            audiobooks: "Hörbücher",
            videos: "Videolektionen",
            courses: "Kurse"
        }
    },

    offline: {
        title: "Sie sind offline",
        text: "Diese Seite ist auf diesem Gerät noch nicht gespeichert. Bitte versuchen Sie es erneut, sobald Sie wieder online sind. Bis dahin können Sie die Bücher lesen, die Sie bereits geöffnet haben.",
        retry: "Erneut versuchen",
        home: "Startseite",
        savedTitle: "Für das Offline-Lesen gespeicherte Bücher",
        savedEmpty: "Sie haben noch keine gespeicherten Bücher. Jedes Buch, das Sie im Leser der Seite öffnen, wird automatisch auf diesem Gerät gespeichert."
    },

    pwa: {
        install: "App installieren"
    },

    notFound: {
        title: "Seite nicht gefunden",
        text: "Die Seite wurde vielleicht verschoben oder existiert nicht mehr. Kehren Sie zur Startseite zurück, um Ihren Weg des Lernens fortzusetzen.",
        back: "Zur Startseite"
    },

    serverError: {
        title: "Etwas ist schiefgelaufen",
        text: "Bei uns ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es in Kürze noch einmal.",
        back: "Zur Startseite"
    }
}
